if (!customElements.get('internal-video')) {
  class InternalVideo extends HTMLElement {
    constructor() {
      super();
      this.onPlayClick = this.togglePlay.bind(this);
      this.onSoundClick = this.toggleSound.bind(this);
      this.onTimeUpdate = this.updateTimeline.bind(this);
      this.onVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('.internal-video__play');
      this.soundButton = this.querySelector('.internal-video__sound-btn');
      this.timeline = this.querySelector('.internal-video__timeline');

      const hasLazySources = this.loadSources();

      if (this.playButton) this.playButton.addEventListener('click', this.onPlayClick);
      if (this.soundButton) this.soundButton.addEventListener('click', this.onSoundClick);

      if (this.video) {
        this.video.addEventListener('timeupdate', this.onTimeUpdate);
        this.video.addEventListener('play', () => this.classList.add('internal-video--playing'));
        this.video.addEventListener('pause', () => this.classList.remove('internal-video--playing'));
      }

      if (this.dataset.autoplay === 'true' || hasLazySources || (this.video && this.video.hasAttribute('autoplay'))) {
        this.startAutoplay();
      }
      if (this.dataset.actionOnInactive) {
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }
    }

    disconnectedCallback() {
      if (this.playButton) this.playButton.removeEventListener('click', this.onPlayClick);
      if (this.soundButton) this.soundButton.removeEventListener('click', this.onSoundClick);
      if (this.video) this.video.removeEventListener('timeupdate', this.onTimeUpdate);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    loadSources() {
      if (!this.video) return false;

      let loadedLazySource = false;
      this.video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        loadedLazySource = true;
      });

      if (loadedLazySource) this.video.load();
      return loadedLazySource;
    }

    startAutoplay() {
      if (!this.video) return;

      this.video.muted = true;
      this.video.autoplay = true;
      this.video.playsInline = true;
      this.classList.add('internal-video--muted');
      this.video.play().catch(() => {});
    }

    togglePlay(event) {
      if (event) event.preventDefault();
      if (!this.video) return;

      if (this.video.paused) {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    }

    toggleSound(event) {
      if (event) event.preventDefault();
      if (!this.video) return;

      this.video.muted = !this.video.muted;
      this.classList.toggle('internal-video--muted', this.video.muted);
    }

    updateTimeline() {
      if (!this.video || !this.timeline || !this.video.duration) return;
      this.timeline.style.setProperty('--progress', `${(this.video.currentTime / this.video.duration) * 100}%`);
    }

    handleVisibilityChange() {
      if (!this.video || this.dataset.actionOnInactive !== 'pause') return;

      if (document.hidden) {
        this.video.pause();
      } else if (this.dataset.autoplay === 'true') {
        this.video.play().catch(() => {});
      }
    }
  }

  customElements.define('internal-video', InternalVideo);
}

window.pauseAllMedia = window.pauseAllMedia || function pauseAllMedia() {
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('iframe').forEach((iframe) => {
    if (iframe.contentWindow) {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  });
};
